import { useMutation, useQueryClient } from "@tanstack/react-query";
import { chatClient } from "@core/clients";
import { OrderChat } from "@core/types";
import { orderChatQueryKeys } from "./keys";

const useEnsureOrderChatMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<OrderChat | null, unknown, number>({
    mutationKey: ["chat", "ensure"],
    mutationFn: (orderId) => chatClient.getOrCreateOrderChat(orderId, { create: true }),
    onSuccess: (chat, orderId) => {
      queryClient.setQueryData<OrderChat | null>(orderChatQueryKeys.byOrder(orderId), chat);
    },
  });
};

export default useEnsureOrderChatMutation;
